import { createSlice } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import initialState from './initialState';
import { 
	setReserveData as setReserveDataReducer,
	setClientData as setClientDataReducer,
	setVehicleData as setVehicleDataReducer,
} from './reducer';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export const reserveSlice = createSlice({
  name: 'reserve',
  initialState: initialState,
  reducers: {
    setReserveData: setReserveDataReducer,
    setClientData: setClientDataReducer,
    setVehicleData: setVehicleDataReducer,
  },
});

export const { setReserveData, setClientData, setVehicleData } = reserveSlice.actions;
/*
export const getInputData = (object, input) => {
  return (state) => state.checkin2[object].form[input];
};
*/


export const allReserveSelector = (state) => state.reserve;
export const reserveSelector = (state) => state.reserve.reserve;
export const clientSelector = (state) => state.reserve.client;
export const vehicleSelector = (state) => state.reserve.vehicle;

export const ciRequired = (state) => {
  const { reserve: { client: { tac_ven_ced }, reserve: { trv_fec_dev } } } = state;
  if (tac_ven_ced !== null && trv_fec_dev !== null){
    const venCed = dayjs(tac_ven_ced, "DD-MM-YYYY");
    const fecTer = dayjs(trv_fec_dev, "YYYY-MM-DD");
    return venCed <= fecTer;
  }else{
    return true;
  }
}
export const licenseRequired = (state) => {
  const { reserve: { client: { tac_ven_lic }, reserve: { trv_fec_dev } } } = state;
  if (tac_ven_lic !== null && trv_fec_dev !== null){
    const venLic = dayjs(tac_ven_lic, "DD-MM-YYYY");
    const fecTer = dayjs(trv_fec_dev, "YYYY-MM-DD")
    return venLic <= fecTer;
  }else{
    return true;
  }
}

export default reserveSlice.reducer;